import { render } from "./designSubForm.vue?vue&type=template&id=ae2fed7e&scoped=true"
import script from "./designSubForm.vue?vue&type=script&lang=js"
export * from "./designSubForm.vue?vue&type=script&lang=js"

import "./designSubForm.vue?vue&type=style&index=0&id=ae2fed7e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae2fed7e"]])

export default __exports__